<template>
  <div class="alert alert-info text-center my-3" v-if="show">
    <i class="bi bi-info-circle me-1"></i> {{ message }}
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "No se encontraron registros que coincidan con la búsqueda."
    }
  }
};
</script>
